// src/contexts/DarkModeContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DarkModeContext = createContext();

export function DarkModeProvider({ children }) {
  const location = useLocation();
  // Define public routes where dark mode should be disabled
  const publicRoutes = ['/', '/login', '/signup', '/forgot-password', '/reset-password', '/verify-code', '/forgot-password-code' ];
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check if the current path is one of the public pages
    const isPublic = publicRoutes.includes(location.pathname);
    
    if (isPublic) {
      // Force light mode on public pages
      document.documentElement.classList.remove('dark');
      setIsDarkMode(false);
    } else {
      // For non-public pages, use the value from localStorage
      const darkSetting = localStorage.getItem('darkMode') === 'true';
      setIsDarkMode(darkSetting);
      if (darkSetting) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
  }, [location.pathname, publicRoutes]);

  const toggleDarkMode = () => {
    // Prevent toggling dark mode on public pages
    if (publicRoutes.includes(location.pathname)) return;

    setIsDarkMode(prev => {
      const newMode = !prev;
      localStorage.setItem('darkMode', newMode);
      if (newMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      return newMode;
    });
  };

  return (
    <DarkModeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
}

export const useDarkMode = () => useContext(DarkModeContext);
